/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Devinfo1Inputs */

const he_error_devinfo1 = /** @type {(inputs: Error_Devinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מידע על השגיאה (מצב פיתוח):`)
};

const en_error_devinfo1 = /** @type {(inputs: Error_Devinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error details (dev mode):`)
};

/**
* | output |
* | --- |
* | "Error details (dev mode):" |
*
* @param {Error_Devinfo1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const error_devinfo1 = /** @type {((inputs?: Error_Devinfo1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Devinfo1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_error_devinfo1(inputs)
	return en_error_devinfo1(inputs)
});
export { error_devinfo1 as "error_devInfo" }